import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";

export default function Videobroadcast() {
  return (
    <section className="licenses antiCorruption development videobroadcast">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title dissertation__title">
        Видеотрансляции
      </h1>
    </section>
  );
}
